export enum States {
  STATE_0 = 'Impaga',
  STATE_1 = 'Impaga',
  STATE_2 = 'En proceso',
  STATE_3 = 'Pagada',
}

export enum StatesColor {
  STATE_0 = 'blue',
  STATE_1 = 'blue',
  STATE_2 = 'orange',
  STATE_3 = 'green',
}

export enum StatesValues {
  STATE_0 = 'STATE_0',
  STATE_1 = 'STATE_1',
  STATE_2 = 'STATE_2',
  STATE_3 = 'STATE_3',
}

